import { http } from "@/http";

export const setStudyName = async(id:string, name:string) => {
	await http.patch(`studies/${id}`, { name });
};